import { render, staticRenderFns } from "./shellScheme.vue?vue&type=template&id=7c803280&scoped=true&"
import script from "./shellScheme.vue?vue&type=script&lang=js&"
export * from "./shellScheme.vue?vue&type=script&lang=js&"
import style0 from "./shellScheme.vue?vue&type=style&index=0&id=7c803280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c803280",
  null
  
)

export default component.exports